import styles from "./InputField.module.scss";

const CheckboxGroup = ({ register, name, errors, label, elements }) => {
  return (
    <div className={styles.field}>
      <label className={styles.field__label}>{label}</label>
      <div className={styles.field__input}>
        {elements.map((el) => (
          <label className={styles.field__element} key={el.value}>
            <input
              type="checkbox"
              className="form-check-input"
              {...register(name + "_" + el.value)}
              name={name + "_" + el.value}
              defaultChecked={el.defalt_check}
            />
            {el.label}
          </label>
        ))}
      </div>
      <p className={`invalid-feedback ${styles.field__msg}`}>
        {errors[name] ? errors[name].message : ""}
      </p>
    </div>
  );
};
export default CheckboxGroup;
